import React from 'react';
import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledNavigation = styled.nav`
  display: flex;
  justify-content: space-between;
  margin-top: 100px;
  padding-top: 50px;
  border-top: 1px solid var(--lightest-navy);

  .nav-link {
    color: var(--green);
    text-decoration: none;
    padding: 10px 0;

    &:hover {
      text-decoration: underline;
    }

    .direction {
      display: block;
      font-size: var(--fz-sm);
      color: var(--slate);
      margin-bottom: 5px;
    }

    .title {
      font-size: var(--fz-md);
      font-weight: 600;
    }
  }

  .prev {
    text-align: left;
  }

  .next {
    text-align: right;
    margin-left: auto;
  }
`;

const ContentNavigation = ({ prev, next, type = 'article' }) => {
  const getTitle = item => {
    if (type === 'article') {
      return item.frontmatter?.title;
    }
    if (type === 'quote') {
      if (!item.html) {
        return '';
      }
      const firstLine = item.html
        .split('\n')[0]
        .replace(/<[^>]*>/g, '')
        .trim();
      const words = firstLine.split(' ').slice(0, 4);
      return words.length < 4 ? words.join(' ') : `${words.join(' ')}...`;
    }
    return '';
  };

  const getPrevLabel = () => (type === 'article' ? '← Previous Article' : '← Previous Quote');

  const getNextLabel = () => (type === 'article' ? 'Next Article →' : 'Next Quote →');

  const isPrevValid = () => {
    if (type === 'article') {
      return prev && prev.fields && prev.frontmatter;
    }
    return prev && prev.fields && prev.html;
  };

  const isNextValid = () => {
    if (type === 'article') {
      return next && next.fields && next.frontmatter;
    }
    return next && next.fields && next.html;
  };

  return (
    <StyledNavigation>
      {isPrevValid() && (
        <Link to={prev.fields.slug} className="nav-link prev">
          <span className="direction">{getPrevLabel()}</span>
          <span className="title">{getTitle(prev)}</span>
        </Link>
      )}

      {isNextValid() && (
        <Link to={next.fields.slug} className="nav-link next">
          <span className="direction">{getNextLabel()}</span>
          <span className="title">{getTitle(next)}</span>
        </Link>
      )}
    </StyledNavigation>
  );
};

ContentNavigation.propTypes = {
  prev: PropTypes.object,
  next: PropTypes.object,
  type: PropTypes.oneOf(['article', 'quote']).isRequired,
};

export default ContentNavigation;
